import { createGlobalStyle } from "styled-components";

const theme = {
  palette: {
    red: "#e11f28",
    darkRed: "#6d1621",
    grey: "#d2d2d2",
  },
  breakpoints: {
    xs: "0px",
    sm: "600px",
    md: "900px",
    lg: "1200px",
    xl: "1536px",
  },
  maxBreakpoints: {
    sm: "599px",
    md: "899px",
    lg: "1199px",
    xl: "1535px",
  },
};

export default theme;

export const GlobalStyles = createGlobalStyle`
  * {
    font-size: 18px;
    line-height: 22px;

    @media screen and (max-width: ${theme.maxBreakpoints.sm}) {
      p {
        font-size: 14px;
        line-height: 17px;
      }
    }
  }

  h1 {
    font-size: 32px;
    line-height: 42px;

    @media screen and (min-width: ${theme.breakpoints.sm}) {
      font-size: 50px;
      line-height: 62px;
    }
  }
`;
